export default "__VITE_PUBLIC_ASSET__d7be1d27__"